'use strict';

import React, { Component } from 'react'

import { DateTime } from 'luxon'

import DatePicker from '@/Form/V2/DatePicker'

import Loader from '@Pure/Loader'

import { num, formatNum } from '@root/utility'

const { app, moment, qwest } = window;

moment.locale('fr');

export default class ECStatistics extends Component
{
	state =
	{
		loading: false,

		from: moment().startOf('year').format('YYYY-MM-DD'),
		to: moment().endOf('year').format('YYYY-MM-DD')
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.fetchEC({ });
	}

	fetchEC ({ from, to })
	{
		const component = this, props = this.props, state = this.state;

		if (!(from || state.from) || !(to || state.to))
		{
			return;
		}

		if (moment(from || state.from).isAfter(to || state.to))
		{
			return component.setState(
			{
				date_error: 'La date de fin doit être antérieure à celle de début.'
			});
		}

		component.setState({ loading: true, date_error: undefined });

		qwest.post('/statistics/EC',
		{
			EC_id: props.id,
			from: from || state.from,
			to: to || state.to
		})
		.then(function (xhr, response)
		{
			component.setState({ ...response, loading: false });
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);
		});
	}

	handleDateChange = ({ e, value, name }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ [name]: value });

		const date = moment(value).isValid()
		? moment(value).format('YYYY-MM-DD')
		: undefined;

		if (date && DateTime.fromISO(value).isValid)
		{
			component.fetchEC({ [name]: date });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		const place_themes_rows = Object.keys(state.themes_amounts || { })
		.map(function (theme_id)
		{
			const amount = num(state.themes_amounts[theme_id].amount);

			return (
				<div className="c-data-row c-data-row--v2" key={ theme_id }>

					<div className="o-grid__item c-data-row__item">
						{ state.themes_amounts[theme_id].label }
					</div>

					<div className="o-grid__item c-data-row__item">
						{ formatNum(state.themes_amounts[theme_id].count, '0,0[.]00') }
					</div>

					<div className="o-grid__item c-data-row__item">
						{ formatNum(amount, '0,0[.]00') + ' €' }
					</div>

				</div>
			);
		});

		let output =
		(
			<div className="c-form u-positioned">

				<div className="c-title c-title--form">
					<div className="c-title__txt">
						Statistiques
					</div>
				</div>

				{ props.children }

				<div className="c-message c-message--green">
					<div className="c-message__content">
						Utilisateurs validés&nbsp;:
						{ ' ' }
						{ state.validated_users_count }
					</div>
				</div>

				<div className="o-grid-2 u-full-width">

					<div className="o-grid__item u-flex u-items-start u-gap-15">

						<DatePicker name="from" label="Du" inline
							onChange={ component.handleDateChange }
							value={ state.from }
						/>

						<DatePicker name="to" label="Au" inline
							onChange={ component.handleDateChange }
							value={ state.to }
						/>

					</div>

				</div>

				{
					state.date_error ?
					(
						<div className="c-message c-message--red">
							<div className="c-message__content">
								{ state.date_error }
							</div>
						</div>
					)
					: undefined
				}

				<div className="table-container u-margin-top-30">

					{ loader }

					<div className="c-table">

						<div className="c-data-row c-data-row--v2 c-data-row--header">

							<div className="o-grid__item c-data-row__item">
								Thème principal
							</div>

							<div className="o-grid__item c-data-row__item">
								Nombre d'articles commandés
							</div>

							<div className="o-grid__item c-data-row__item">
								Chiffre d'affaires
							</div>

						</div>

						{ place_themes_rows }

						<div className="c-data-row c-data-row--v2">

							<div className="o-grid__item c-data-row__item">
								Toutes les cmdes
							</div>

							<div className="o-grid__item c-data-row__item">
								{ formatNum(state.articles_count, '0,0') }
							</div>

							<div className="o-grid__item c-data-row__item">
								{ formatNum(state.total_amount, '0,0[.]00') + ' €' }
							</div>

						</div>

					</div>

				</div>

			</div>
		);

		return output;
	}
}